module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Peter Kamau Wanyoike.2642a242.jpg";